<template>
  <div class="comp-xl-edit-div">
    <div class="chitchat edit-input-content">
      <div id="editDivBody" class="edit-input-content">
        <div class="headPortrait edit-input-content">
          <div ref="editInputRef" class="editSelInputDiv edit-input-content" :id="controlDivId" :class="isContent ? 'showContent' : ''" contenteditable="true" @input="editInput" @keydown="handleKeyDown" :placeholder="$t(data.placeholder)" v-html="data.innerHtml" @paste="handlePaste" @click="handleFocus"></div>
          <jw-space class="edit-input-space">
            <div>
              <jw-trigger v-if="isShowColor" trigger="click" :popup-container="`.edit-input-content`" position="br" :unmount-on-close="false">
                <icon-palette size="20" :style="{ backgroundColor: defaultColor?.label }" class="palette-icon" />
                <template #content>
                  <div class="color-array">
                    <div>{{ $t('标题背景色') }}</div>
                    <div class="title-color">
                      <div v-for="(item, index) in data.colorList" :key="index" :style="{ backgroundColor: item.label }" @click="switchColor(item)" :class="[item.status ? 'title-color-action' : '']" class="title-color-item"></div>
                      <div @click="switchColor({ label: '#fff', value: 'default', status: false })" class="oblique"></div>
                    </div>
                  </div>
                </template>
              </jw-trigger>
            </div>

            <div class="editAddIcon" v-if="isShowBtn">
              <jw-dropdown
                position="tl"
                @select="fieldSelect"
                @popup-visible-change="
                  () => {
                    searchData = '';
                  }
                "
              >
                <icon-plus-circle-fill size="20" />
                <template #content>
                  <jw-dsubmenu>
                    <template #default>{{ $t('对象字段') }}</template>
                    <template #content>
                      <jw-input-search v-model="searchData" :placeholder="$t('搜索插入字段')" class="select_field_content select_search_field" allow-clear @clear="fieldSearch($event, index)" />
                      <jw-doption v-for="item in searchData && searchData !== '' ? allFields?.filter((fItem) => fItem.fieldName.includes(searchData)) : allFields" :key="item.fieldKey" :value="item">{{ item.fieldName }}</jw-doption>
                    </template>
                  </jw-dsubmenu>
                  <jw-dsubmenu>
                    <template #default>{{ $t('节点信息') }}</template>
                    <template #content>
                      <jw-doption v-for="item in nodeFields" :key="item.fieldKey" :value="item">{{ item.fieldName }}</jw-doption>
                    </template>
                  </jw-dsubmenu>
                </template>
              </jw-dropdown>
            </div>
          </jw-space>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
let editDiv = null; //编辑元素
let range = ''; //区域对象
// import { CLIENT_RENEG_WINDOW } from 'tls';
import { reactive, ref, inject, computed, onMounted, onBeforeUnmount } from 'vue';
const props = defineProps({
  fieldList: {
    //对象字段
    type: Object
  },
  funList: {
    //函数类
    type: [Object, Array]
  },
  placeholder: {
    type: String,
    default: '请输入计算公式内容'
  },
  showAddButton: {
    type: Boolean,
    default: false
  },
  showColorButton: {
    type: Boolean,
    default: false
  },
  isContent: {
    type: Boolean,
    default: false // 是否内容区域
  },
  field: {
    type: String,
    default: '' // 表单的字段
  },
  defaultColor: {
    type: String,
    default: ''
  },
  controlId: {
    type: String,
    default: ''
  },
  colorList: {
    type: Array,
    default: () => []
  }
});

const data = reactive({
  innerHtml: '', // 初始化赋值
  uploadHtml: true,
  placeholder: props.placeholder,
  colorList: ref(props.colorList)
});

const controlDivId = ref(props.controlId); //  选区控制的容器id
const { getFormula, showFunTips } = inject('methods'); //父组件方法
const editInputRef = ref();
const isShowBtn = ref(props.showAddButton); //  添加字段
const isShowColor = ref(props.showColorButton); // 添加颜色
const allFields = ref(props.fieldList);
const nodeFields = ref([
  {
    id: 'currentOperator',
    fieldName: '当前操作人',
    fieldType: 1,
    fieldKey: 'currentOperator'
  },
  {
    id: 'currentOperationTime',
    fieldName: '当前操作时间',
    fieldType: 1,
    fieldKey: 'currentOperationTime'
  },
  {
    id: 'currentOperationNode',
    fieldName: '当前节点',
    fieldType: 1,
    fieldKey: 'currentOperationNode'
  }
]); // 节点信息字段
const isContent = ref(props.isContent);
const changeField = ref(props.field);
const defaultColor = ref(data.colorList.find((cItem) => cItem.value === props.defaultColor) || data.colorList[0]);
const searchData = ref('');

console.log('默认颜色', defaultColor, data.colorList);

const emits = defineEmits(['updateColor']);

const fieldSelect = (fieldItem, index) => {
  console.log('字段选择', index);
  let getFormulaText = '';
  let getFormulaKey = '';
  // let entityId = '';
  let getFormulaFieldType = '';
  // 创建一个新对象，只包含指定索引之前的部分
  getFormulaText = fieldItem.fieldName;
  getFormulaKey = fieldItem.fieldKey;
  // entityId = fieldItem.entityId;
  getFormulaFieldType = fieldItem.fieldType;
  console.log('选择的字段', getFormulaText);
  insertInnerTextFun(getFormulaText, 1, getFormulaKey, getFormulaFieldType, editInputRef.value);
};

const fieldList = computed(() => {
  return props.fieldList;
});

onMounted(() => {
  initEditFun();
});

const switchColor = (item) => {
  console.log('选择的颜色', item);
  // eslint-disable-next-line no-debugger
  // debugger;
  // data.colorList.forEach((e) => {
  //   e.status = false;
  // });
  // item.status = true;
  defaultColor.value = item;
  emits('updateColor', defaultColor.value);
};

// 获取当前选取
const getRangeFromSelection = () => {
  // 获取用户的选区
  const selection = window.getSelection();
  console.log('用户选区', selection);

  // 检查是否存在选区，并获取第一个选区（如果存在）
  if (selection && selection.rangeCount > 0) {
    return selection.getRangeAt(0);
  } else {
    return null;
  }
};

// 失去焦点
const onBlur = () => {
  console.log('失去焦点前----', range);
  if (!range || (range && !hasAncestorWithId(range.commonAncestorContainer, controlDivId.value))) {
    range = getRangeFromSelection();
    resetSelDiv();
  }
};

// 选取改变事件
const onChange = () => {
  const rangeVal = getRangeFromSelection();
  console.log('用户选区111', window.getSelection()?.getRangeAt);
  if (rangeVal && hasAncestorWithId(rangeVal.commonAncestorContainer, controlDivId.value)) {
    range = getRangeFromSelection();
  }
};

// 获取选区区域
const initEditFun = () => {
  editDiv = document.getElementById(controlDivId.value);
  // 这一步是保留住edit编辑框中的选区的范围对象。
  // 否则失焦后，getSelection()方法返回的选区对象已经不再是编辑框了，已经获取不到编辑框中的范围对象了。
  //页面卸载已移除监听 避免内存泄露
  editDiv.addEventListener('blur', onBlur);
  //选择的范围改变时才会被触发
  // 页面卸载已移除监听 避免内存泄露
  document.addEventListener('selectionchange', onChange);
};
// 递归判断是否有父级id = editSelDiv
const hasAncestorWithId = (element, id) => {
  if (!element) return false;
  if (element.id === id) return true;
  if (element.parentNode) {
    return hasAncestorWithId(element.parentNode, id);
  }
  return false;
};

// 处理详情数据
const setFormInput = (formula, field_list) => {
  data.uploadHtml = false;
  if (formula) {
    const parser = new DOMParser(); //DOMParser 可以将存储在字符串中的 XML 或 HTML 源代码解析为一个 DOM Document。
    const htmlDoc = parser.parseFromString(formula, 'text/html');
    const selFieldSpans = htmlDoc.querySelectorAll('.selField');
    selFieldSpans?.forEach((span) => {
      const dataVal = span.dataset.value;
      const findField = field_list?.find((el) => el.fieldKey == dataVal);
      //   console.log('findField---', findField);
      if (findField) {
        //无效引用
        if (!findField.isEnabled) {
          span.classList.add('selField-invalid');
          span.innerHTML = `无效引用`;
        } else {
          span.innerHTML = `${findField?.fieldName}`;
        }
      }
    });
    data.innerHtml = htmlDoc.body.innerHTML;
    // getNowContent();
  }
  if (!range || range == '') {
    setTimeout(() => {
      resetSelDiv();
    }, 1);
  }
};

//输入事件
const editInput = (e) => {
  getNowContent(); //获取最新内容
  handleFocus(); //监听函数提示说明事件
  if (e.target.innerText == '') {
    range = '';
    e.target.innerHtml = '';
    data.innerHtml = '';
  }
};

// 更新内容
const updateRange = (dom, start, end, keyword) => {
  const range = getRangeFromSelection();
  range.setStart(dom, start);
  range.setEnd(dom, end);
  range.deleteContents();
  const createNode = document.createElement('span');
  createNode.contentEditable = false;
  createNode.className = 'selField';
  createNode.innerHTML = keyword.fieldName;
  createNode.setAttribute('data-value', keyword.fieldKey);
  // createNode.setAttribute('data-type', keyword.fieldType);
  // createNode.setAttribute('data-entityId', keyword.entityId);
  range.insertNode(createNode);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
  sel.collapseToEnd();
  getNowContent();
};

// 键盘按下
const handleKeyDown = (e) => {
  if (e.key === 'Enter' || (e.shiftKey && e.key === 'Enter')) {
    // 过滤空格 换行
    console.log('组合键', e);
    e.preventDefault(); // 阻止默认的添加
    document.execCommand('insertLineBreak');
    handleKeyUp(); //处理字段
    handleFocus(); //函数提示
  }
};

// 键盘抬起
const handleKeyUp = () => {
  var fieldKeyword = fieldList.value; //对象字段
  const selection = window.getSelection();
  const offset = selection.focusOffset;

  if (selection.focusNode?.data) {
    const keyword = fieldKeyword.find((item) => selection.focusNode.data.includes(item.fieldName));
    // console.log(keyword);
    if (keyword) {
      // 当输入内容中有 关键字 则替换为 span节点
      const start = getClosestIndex(
        selection.focusNode.data,
        keyword.fieldName,
        min([offset + 1, selection.focusNode.data.length - 1]), // offset + 1 查找开始字符从光标位置后一位开始找，更保险一些。避免超出字符长度，所以加了min处理
        -1
      );
      const end = getClosestIndex(selection.focusNode.data, keyword.fieldName, max([offset - 1, 0]), 1); // offset - 1 ，查找结尾的时候，从当前光标前一位找
      //   console.log(start, end);
      if (start != undefined && end != undefined) {
        updateRange(selection.focusNode, start, end, keyword);
      }
    }
  }
};

// 点击输入框聚焦
const handleFocus = () => {
  const selection = window.getSelection();
  const offset = selection.focusOffset; //返回一个数字，表示该选区终点在focusNode中的位置偏移量。
  const findFocusNode = selection.focusNode.data; //返回该选区终点所在的节点。
  if (findFocusNode) {
    // console.log('偏移量', offset);
    // console.log('文本', findFocusNode, findFocusNode.length);

    const setOffset = offset == findFocusNode.length ? offset - 1 : offset;
    // console.log('偏移量处理',setOffset);
    const funObj = [];
    props.funList?.forEach((item) => {
      funObj.push(...item.functionList);
    });
    const findFunList = [];
    funObj?.map((item) => {
      if (findFocusNode == item.name || findFocusNode == item.nameWithBrackets || findFocusNode == item.functionName) {
        findFunList.push(item);
      }
    });
    // console.log('findFunList----', findFunList);
    if (findFunList?.length > 0) {
      showFunTips(true, findFunList[0]);
    } else {
      const findFunKey = [];
      funObj?.map((item) => {
        if (findFocusNode.includes(item.name) || findFocusNode.includes(item.nameWithBrackets)) {
          findFunKey.push(item);
        }
      });
      const splitFun = findFocusNode.split('')[setOffset];
      // console.log('findFunKey---', findFunKey);
      // console.log('splitFun----', splitFun);
      if (findFunKey?.length > 0) {
        for (let i = 0; i < findFunKey.length; i++) {
          if (findFunKey[i].functionName.split('').indexOf(splitFun) != -1) {
            showFunTips(true, findFunKey[i]);
            return false;
          } else {
            showFunTips(false);
          }
        }
      } else {
        showFunTips(false);
      }
    }
  } else {
    showFunTips(false);
  }
  if (selection && selection?.focusNode?.parentNode?.className == 'selField') {
    resetSelDiv();
  }
};

// 获取 选取文本 关键字 开头/结尾 所处的光标位置
const getClosestIndex = (str = '', keyword, index = 0, step) => {
  const arr = str.split('');
  const len = arr.length;
  // 根据 step 值，获取需要查找的字符，如果 -1 要找开头字符，1找结尾字符
  const char = (step === -1 ? keyword?.[0] : keyword[keyword.length > 0 ? keyword.length - 1 : 0]) || '';
  const commonCondition = arr[index] === char; //判断当前字符是否等于 查找的字符
  if (commonCondition && ((step === -1 && str.substring(index, index + keyword.length) === keyword) || (step === 1 && str.substring(index + 1 - keyword.length, index + 1) === keyword))) {
    // 避免 关键字中出现重复字符，导致判断条件提前结束，所以增加判断条件
    // 当满足 commonCondition 时，且（-1时，向后截取 关键字长度 字符与关键字相等）/（1时，向前截取 关键字长度 字符与关键字相等），则说明找到了关键字的光标
    return step > 0 ? min([len, index + 1]) : max([0, index]);
  } else if (index >= 0 && index < len) {
    // 不满足条件，继续查找
    return getClosestIndex(str, keyword, index + step, step);
  }
};

// 获取最小值
const min = (arr) => {
  return arr.reduce((min, current) => (current < min ? current : min), arr[0]);
};
// 获取最大值
const max = (arr) => {
  return arr.reduce((max, current) => (current > max ? current : max), arr[0]);
};

// 把字段名关键字匹配成span标签
const versionSpan = (str, objArray) => {
  // 先去除字符串中的回车和空格
  str = str.replace(/\r?\n|\s+/g, '');
  let regexPattern = '('; //生成匹配字段名的正则
  for (const obj of objArray) {
    regexPattern += obj.fieldName + '|';
  }
  regexPattern = regexPattern.slice(0, -1); // 去掉最后一个'|'
  regexPattern += ')';
  const regex = new RegExp(regexPattern, 'g');

  //   const newStr = replaceOperatorsWithSpan(str, operatorOptions);
  return str.replace(regex, (matchedFieldName) => {
    // 找到与当前匹配字段名对应的对象
    const matchedObject = objArray.find((obj) => obj.fieldName === matchedFieldName);

    // 创建并返回带有data-field-key属性的span元素
    if (matchedObject) {
      return `<span class="selField" contentEditable="false" data-value="${matchedObject.fieldKey}" data-type="${matchedObject.fieldType}" data-entityId="${matchedObject.entityId}"><span class="img-span"></span>${matchedFieldName}</span>`;
    } else {
      return matchedFieldName; // 如果没有找到匹配的对象，则原样返回字段名
    }
  });
};

// 粘贴
const handlePaste = (event) => {
  var e = event || window.event;
  // 阻止默认粘贴
  e.preventDefault();
  // 粘贴事件 clipboardData的属性，获取剪贴板的内容
  // clipboardData的getData(fomat) 获取指定格式的数据
  var text = e?.clipboardData?.getData('text/plain') || '';
  var fieldKeyword = fieldList.value; //对象字段
  const htmlString = versionSpan(text, fieldKeyword || []);
  //   console.log("test---",text)
  //   console.log("htmlString---",htmlString)

  // 创建一个临时template用于解析HTML字符串为DOM节点
  const template = document.createElement('template');
  template.innerHTML = htmlString.trim();
  const newNode = template.content;
  //   console.log("newNode---",newNode)
  const selection = window.getSelection();
  if (!selection) return; // 如果没有选区，则不执行后续操作
  const range = selection.getRangeAt(0);
  // 删除当前选区内容
  range.deleteContents();
  range.insertNode(newNode);
  selection.removeAllRanges();
  selection.addRange(range);
  selection.collapseToEnd();
  getNowContent();
};

// 插入内容 文本，操作符，字段key，字段id,字段名合集
const insertInnerTextFun = (Text, op, key, type, currentDiv) => {
  console.log('当前ddiv', currentDiv);
  let createNode;
  if (op == 1) {
    //插入的是字段
    createNode = document.createElement('span');
    createNode.innerHTML = Text;
    createNode.className = 'selField';
    createNode.contentEditable = false;
    createNode.setAttribute('data-value', key);
    // createNode.setAttribute('data-id', id);
    createNode.setAttribute('data-type', type);
    // createNode.setAttribute('data-entityId', entityId);
  }
  if (!range || (range && !hasAncestorWithId(range.commonAncestorContainer, controlDivId.value))) {
    resetSelDiv();
  }
  const sel = window.getSelection(); // 当前光标位置

  // 检查当前光标是否在 currentDiv 内
  // intersectsNode 返回一个指定的Node是否与range相交
  // selectNodeContents 用于设置rang，使其包含指定Node的内容
  if (sel.rangeCount > 0) {
    // 是否有光标 0， 1
    if (currentDiv && range.intersectsNode(currentDiv)) {
      // 如果当前光标在 currentDiv 内，则插入节点
      range.insertNode(createNode);
    } else {
      // 如果当前光标不在 currentDiv 内，则创建一个新的选区并插入节点
      range.selectNodeContents(currentDiv);
      range.collapse(false); // 选区折叠到结尾
      // 插入节点
      range.insertNode(createNode); //在指定Node结尾插入节点
      // 移动光标到插入节点的后面
    }
  }

  // range.insertNode(createNode); // insertNode方法，在range选区开头插入一个节点

  sel.removeAllRanges(); //删除之前的所有选区。
  sel.addRange(range);
  sel.collapseToEnd(); //并把光标定位在原选区的最末尾处，
  getNowContent();
};

const resetSelDiv = () => {
  const selection = window.getSelection();
  selection.selectAllChildren(editDiv); //将div中子节点全部选中
  selection.collapseToEnd(); //将当前的选区折叠到最末尾的一个点。
  range = getRangeFromSelection(); // 无论哪一步都需要保存当前编辑框的选区对象
};
// 获取最新的内容
const getNowContent = () => {
  getFormula(editInputRef.value.innerHTML, changeField.value);
};

onBeforeUnmount(() => {
  editDiv.removeEventListener('blur', onBlur);
  //选择的范围改变时才会被触发
  document.removeEventListener('selectionchange', onChange);
  editDiv = null; //编辑元素
  range = ''; //选区
});

// 清空内容
const clearContent = () => {
  editInputRef.value.innerHTML = '';
  getFormula(editInputRef.value.innerHTML, changeField.value);
};
defineExpose({
  insertInnerTextFun,
  setFormInput,
  clearContent
});
</script>
<style scoped lang="less">
@import './xl-edit-div.less';
</style>
